<template>
  <div v-if="events.data" class="landing-featured-events-holder">
    <div class="carousel_title" style="font-size: 24px; color: var(--text-color); font-weight: 800; line-height: 33px">Featured Events
      <div style="display: inline-block">
        <calendar-marquees v-if="!checkMobileDevice()" style="margin-left: 15px" :type="marqueesType" @change-type="changeTypeMarquees" />
      </div>
      <div style="display: inline-flex">
        <div class="landing_event_btn">
          <a
            class=""
            :href="routePubgEvents()"
            style="position:static; color: white"
          >View All Events</a>
        </div>
        <div v-if="!checkMobileDevice()" class="landing_event_btn">
          <a
            class="view_all_event"
            :href="routePubgCreateEvent('create')"
            style="position:static; color: white"
          >Create An Event</a>
        </div>
      </div>
    </div>
    <keep-alive>
      <event-slider v-if="events.data.count > 0 && marqueesType === 'grid'" :events="events" :is-grid-view="false" page="landing" slide-to-show="4" />
    </keep-alive>
    <keep-alive>
      <event-calendar v-if="!checkMobileDevice() && marqueesType === 'calendar'" />
    </keep-alive>
  </div>
</template>

<script>
import { component } from '../../../../../mixins/component';
import EventSlider from '../../../../../components/events/EventSlider';
import EventCalendar from '../../../../../components/events/EventCalendar';
import CalendarMarquees from '../../../../../components/shared/CalendarMarquees';
import { helper } from '../../../../../mixins/helper';
import { EventBus, CLOSE_EVENT_CALENDAR } from '../../../../../event-bus';

export default {
  components: { EventSlider, CalendarMarquees, EventCalendar },
  mixins: [component, helper],
  props: {
    events: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      marqueesType: 'grid',
    };
  },
  created() {
    EventBus.$on(CLOSE_EVENT_CALENDAR, this.closeEventCalendar);
  },
  destroyed() {
    EventBus.$off(CLOSE_EVENT_CALENDAR);
  },
  methods: {
    changeTypeMarquees(type) {
      this.marqueesType = type;
    },
    closeEventCalendar() {
      this.marqueesType = 'grid';
    },
  },
};
</script>
